module.exports = __webpack_public_path__ + "img/local_icon.e289fc0a.svg";